import Lenis from 'lenis';
import { gsap, ScrollTrigger } from './gsap-config.js';

class LenisController {
  constructor(options = {}) {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      ...options
    });

    this.isRunning = false;
    this.init();
  }

  init() {
    this.lenis.on('scroll', ScrollTrigger.update);
    
    gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    this.start();
  }

  start() {
    if (!this.isRunning) {
      this.isRunning = true;
      console.log('✅ Lenis smooth scroll started');
    }
  }

  stop() {
    if (this.isRunning) {
      this.lenis.stop();
      this.isRunning = false;
      console.log('⏸️ Lenis smooth scroll stopped');
    }
  }

  scrollTo(target, options = {}) {
    this.lenis.scrollTo(target, {
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      ...options
    });
  }

  destroy() {
    this.lenis.destroy();
    gsap.ticker.remove((time) => {
      this.lenis.raf(time * 1000);
    });
    console.log('🗑️ Lenis destroyed');
  }

  on(event, callback) {
    this.lenis.on(event, callback);
  }

  off(event, callback) {
    this.lenis.off(event, callback);
  }
}

export default LenisController; 